import { Link } from 'react-router-dom';
import { Camera, Heart, Dices, Palette } from 'lucide-react';
import { Button } from './ui/button';

const cards = [
  {
    id: 'post',
    icon: Camera,
    title: 'Recent Post',
    subtitle: 'Share your first FoodCard!',
    cta: 'Post Now',
    link: '/foodie',
    image: 'https://images.unsplash.com/photo-1504674900247-0877df9cc836?w=400&q=60',
    delay: '0s',
  },
  {
    id: 'dish',
    icon: Heart,
    title: 'Favorite Dish',
    subtitle: 'Save a dish to your Foodlist',
    cta: 'Explore',
    link: '/surprise',
    image: 'https://images.unsplash.com/photo-1546069901-ba9599a7e63c?w=400&q=60',
    delay: '0.08s',
  },
  {
    id: 'quest',
    icon: Dices,
    title: 'Quest Badge',
    subtitle: 'Complete a quest to earn points',
    cta: 'Start',
    link: '/quests',
    image: 'https://images.unsplash.com/photo-1555939594-58d7cb561ad1?w=400&q=60',
    delay: '0.16s',
  },
  {
    id: 'taste',
    icon: Palette,
    title: 'Taste Profile',
    subtitle: 'Update your vibe & cuisine',
    cta: 'Update',
    link: '/profile',
    tabTarget: 'taste',
    image: 'https://images.unsplash.com/photo-1482049016688-2d3e1b311543?w=400&q=60',
    delay: '0.24s',
  },
];

const ProfileEmptyCards = ({ onTabChange }) => (
  <div className="space-y-8 animate-fade-in-up">
    <p className="text-center text-gray-500 text-base">
      Your food journey starts here! Share moments on the Foodie Feed.
    </p>

    <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
      {cards.map((card) => {
        const Icon = card.icon;
        const inner = (
          <div
            key={card.id}
            data-testid={`empty-card-${card.id}`}
            className="group relative rounded-2xl overflow-hidden shadow-md hover:shadow-xl transition-all duration-300 hover:-translate-y-1 opacity-0 animate-fade-in-up"
            style={{ animationDelay: card.delay, animationFillMode: 'forwards' }}
          >
            <div className="aspect-square relative">
              <img
                src={card.image}
                alt={card.title}
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent" />

              <div className="absolute bottom-0 left-0 right-0 p-4 flex flex-col gap-2">
                <div className="flex items-center gap-2">
                  <div className="w-8 h-8 rounded-lg bg-[#FF6B35] flex items-center justify-center">
                    <Icon className="w-4 h-4 text-white" />
                  </div>
                  <div>
                    <h4 className="text-white font-bold text-sm leading-tight">{card.title}</h4>
                    <p className="text-white/70 text-xs">{card.subtitle}</p>
                  </div>
                </div>
                <Button
                  size="sm"
                  data-testid={`empty-card-cta-${card.id}`}
                  className="w-full bg-[#FF6B35] hover:bg-[#E85D04] text-white text-xs font-semibold rounded-xl h-9"
                >
                  {card.cta}
                </Button>
              </div>
            </div>
          </div>
        );

        if (card.tabTarget) {
          return (
            <div key={card.id} onClick={() => onTabChange?.(card.tabTarget)} className="cursor-pointer">
              {inner}
            </div>
          );
        }

        return (
          <Link key={card.id} to={card.link}>
            {inner}
          </Link>
        );
      })}
    </div>

    <div className="text-center">
      <Link to="/foodie">
        <Button
          data-testid="empty-state-go-foodie-btn"
          className="bg-[#FF6B35] hover:bg-[#E85D04] text-white px-8 py-3 text-base rounded-xl shadow-lg shadow-[#FF6B35]/20"
        >
          Go to Foodie Feed
        </Button>
      </Link>
    </div>
  </div>
);

export default ProfileEmptyCards;
